import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routeHistoryReducer } from './RouteHistory';
import { trackingReducer } from './Tracking';
import { TrackingSagasListener } from './Tracking/sagas';

const sagaMiddleware = createSagaMiddleware();
const middleware = applyMiddleware(sagaMiddleware);

export const trackingStoreReducer = combineReducers({
  tracking: trackingReducer,
  routesHistory: routeHistoryReducer,
});

export const trackingStore = createStore(trackingStoreReducer, undefined, compose(middleware));
[TrackingSagasListener].forEach(sagaMiddleware.run);

export type TrackingState = ReturnType<typeof trackingStoreReducer>;
